import React, { useMemo } from 'react';
import './HappyBackground.css';

const Butterfly = React.memo(({ x, y, delay, color }: { 
  x: number; 
  y: number;
  delay: number;
  color: string;
}) => (
  <div 
    className="butterfly"
    style={{
      '--butterfly-x': x,
      '--butterfly-y': y,
      '--butterfly-color': color,
      animationDelay: `${delay}s`
    } as React.CSSProperties}
  />
));

const Flower = React.memo(({ x, y, type }: { 
  x: number; 
  y: number;
  type: string;
}) => (
  <div 
    className={`flower flower-${type}`}
    style={{
      left: `${x}%`,
      bottom: `${y}%`,
    }}
  />
));

const HappyBackground = React.memo(() => {
  const butterflies = useMemo(() => 
    Array.from({ length: 8 }).map((_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: 20 + Math.random() * 60,
      delay: Math.random() * 6,
      color: ['#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7'][Math.floor(Math.random() * 5)]
    })),
  []);

  const flowers = useMemo(() => 
    Array.from({ length: 25 }).map((_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 30,
      type: ['daisy', 'tulip', 'rose'][Math.floor(Math.random() * 3)]
    })),
  []);

  return (
    <div className="happy-background">
      {/* Sky Gradient */}
      <div className="happy-sky" />
      
      {/* Sun */}
      <div className="happy-sun">
        <div className="sun-rays" />
      </div>
      
      {/* Rolling Hills */}
      <div className="happy-hills">
        <div className="hill hill-back" />
        <div className="hill hill-mid" />
        <div className="hill hill-front" />
      </div>
      
      {/* Grass Layer */}
      <div className="happy-grass" />
      
      {/* Flowers */}
      <div className="flowers-layer">
        {flowers.map(flower => (
          <Flower
            key={flower.id}
            x={flower.x}
            y={flower.y}
            type={flower.type}
          />
        ))}
      </div>
      
      {/* Butterflies */}
      <div className="butterflies-layer">
        {butterflies.map(butterfly => (
          <Butterfly
            key={butterfly.id}
            x={butterfly.x}
            y={butterfly.y}
            delay={butterfly.delay}
            color={butterfly.color}
          />
        ))}
      </div>
      
      {/* Floating particles */}
      <div className="happy-particles" />
    </div>
  );
});

export default HappyBackground;